import { CdkStepper } from '@angular/cdk/stepper';
import { Component } from '@angular/core';

@Component({
    selector: 'sgt-negocio-form-insert-stepper',
    templateUrl: './negocio-form-insert-stepper.component.html',
    styleUrls: ['./negocio-form-insert-stepper.component.less'],
    providers: [{ provide: CdkStepper, useExisting: NegocioFormInsertStepperComponent}]
})
export class NegocioFormInsertStepperComponent extends CdkStepper { }
